import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function AgentNoteAdd() {
    const { http, user } = AuthUser();
    const navigate = useNavigate();
    const [agents, setAgents] = useState([]);
    const [formData, setFormData] = useState({
        agent_id: "",
        note: "",
        user_id: user.id,
        company_id: user.company_id,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = () => {
        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            if (Array.isArray(res.data.data)) {
                setAgents(res.data.data);
            }
        });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await http.post("/agent_note_add", formData);

            if (response.data.status === 'success') {
                toast.success("Agent note added successfully!");
                navigate("/agent_note_list");
            } else {
                toast.error(response.data.message || "Failed to add note");
            }
        } catch (error) {
            console.error("Error adding note:", error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("An error occurred while adding the note.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Toaster />
            <div className="container mt-2">
                <div className="row">
                    <h3>Add Agent Note</h3>
                    <hr />
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group mt-3">
                                <label>Select Agent <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    name="agent_id"
                                    value={formData.agent_id}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Agent</option>
                                    {agents.map((agent) => (
                                        <option key={agent.id} value={agent.id}>
                                            {agent.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group mt-3">
                                <label>Note <span className="text-danger">*</span></label>
                                <textarea
                                    className="form-control"
                                    name="note"
                                    rows="8"
                                    value={formData.note}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter note here..."
                                />
                            </div>

                            <div className="form-group mt-3">
                                <button
                                    type="submit"
                                    className="btn button btn-success"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Adding..." : "Add Note"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={() => navigate("/agent_note_list")}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

